import { put, call } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { fetchReportFactorySuccess, fetchReportFactoryRequest, fetchReportFactoryFailure } from "./report-factory";
import { fetchReportFactory } from "../../api/api";

export function* handleFetchReportFactory(action: ReturnType<typeof fetchReportFactoryRequest>): SagaIterator {
  try {
    const params = action.payload;
    const data = yield call(fetchReportFactory, params);
    yield put(fetchReportFactorySuccess({ data, params }));
  } catch (error) {
    yield put(fetchReportFactoryFailure(error.message));
  }
}
